import React from 'react';
import { Provider } from 'react-redux'
import { CssBaseline } from "@material-ui/core";
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles'

//:: Theme / Locale / CSS / Store
import './../../css/Main.css'
import Theme from '../../theme/Theme'
import Store from '../../class/store/Store'

//:: Constants
import { ROUTER } from '../../class/constants'

//:: Components
import {
  BlockScreen,
  FinancialScreen,
  LoginScreen,
  BlockCnpjScreen,
  BlockEmailScreen,
  PlanScreen,
  PlanSearchScreen,
  PlanSearchCnpjScreen,
  PlanSearchEmailScreen,
  FinancialConfigScreen,
  FilterScreen,
  FilterListScreen,
  NotificationScreen,
  LogScreen,
  CustomerScreen,
  ProductScreen,
  ProductSearchScreen,
  ProductSearchEmailScreen,
  ProductSearchCnpjScreen
} from '../screen'
import FinancialCnpjScreen from '../screen/protectedScreens/FinancialCnpjScreen';
import FinancialEmailScreen from '../screen/protectedScreens/FinancialEmailScreen';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

function App() {
  return (
    <React.StrictMode>
      <Provider store={Store}>
        <BrowserRouter>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <div className='App'>
              <StylesProvider injectFirst>
                <MuiThemeProvider theme={Theme}>
                  <CssBaseline />
                  <Switch>
                    { /* UNPROTECTED ROUTES */}
                    <Route path={ROUTER.LOGIN} render={(props) => <LoginScreen {...props} />} />

                    { /* PROTECTED ROUTES  */}
                    <Route path={ROUTER.BLOCK_SEARCH.CNPJ} component={BlockCnpjScreen} />
                    <Route path={ROUTER.BLOCK_SEARCH.EMAIL} component={BlockEmailScreen} />
                    <Route path={ROUTER.BLOCK} component={BlockScreen} />
                    <Route path={ROUTER.CUSTOMER} component={CustomerScreen} />

                    <Route path={ROUTER.FINANCIAL_CONFIG} component={FinancialConfigScreen} />

                    <Route path={ROUTER.FINANCIAL_SEARCH.CNPJ} component={FinancialCnpjScreen} />
                    <Route path={ROUTER.FINANCIAL_SEARCH.EMAIL} component={FinancialEmailScreen} />
                    <Route path={ROUTER.BILLING} component={FinancialScreen} />
                    <Route path={ROUTER.FINANCIAL} component={FinancialScreen} />

                    <Route path={ROUTER.CUSTOMER_PLAN_TABLE.SEARCH_CNPJ} component={PlanSearchCnpjScreen} />
                    <Route path={ROUTER.CUSTOMER_PLAN_TABLE.SEARCH_EMAIL} component={PlanSearchEmailScreen} />
                    <Route path={ROUTER.CUSTOMER_PLAN_TABLE.SEARCH} component={PlanSearchScreen} />
                    <Route path={ROUTER.PLANS} component={PlanScreen} />

                    <Route path={ROUTER.FILTERS_MANAGE} component={FilterScreen} />
                    <Route path={ROUTER.FILTERS} component={FilterListScreen} />
                    <Route path={ROUTER.FILTERS_LIST} component={FilterListScreen} />
                    
                    <Route path={ROUTER.CUSTOMER_PRODUCT_TABLE.SEARCH_CNPJ} component={ProductSearchCnpjScreen} />
                    <Route path={ROUTER.CUSTOMER_PRODUCT_TABLE.SEARCH_EMAIL} component={ProductSearchEmailScreen} />
                    <Route path={ROUTER.CUSTOMER_PRODUCT_TABLE.SEARCH} component={ProductSearchScreen} />
                    <Route path={ROUTER.PRODUCTS} component={ProductScreen} />

                    <Route path={ROUTER.NOTIFICATIONS} component={NotificationScreen} />
                    <Route path={ROUTER.LOG} component={LogScreen} />


                    { /* ANY ROUTE FALLS HERE */}
                    <Route component={LoginScreen} />
                  </Switch>
                </MuiThemeProvider>
              </StylesProvider>
            </div>
          </MuiPickersUtilsProvider>
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  )
}

export default App;